import {
  type ContextType,
  type Dispatch,
  type FC,
  type Key,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

const Context = createContext<
  | {
      selectedRowKeys: Array<Key>;
      setSelectedRowKeys: Dispatch<SetStateAction<Array<Key>>>;
      clearAllSelections: () => void;
    }
  | undefined
>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);

  if (!context) {
    throw new Error(
      'useTableRowSelection must be used within TableRowSelectionProvider.',
    );
  }

  return context;
};

export const useTableRowSelection = () => {
  return _useContext();
};

export const TableRowSelectionProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<Array<Key>>([]);

  const clearAllSelections = () => {
    setSelectedRowKeys([]);
  };

  return (
    <Context.Provider
      value={{ selectedRowKeys, setSelectedRowKeys, clearAllSelections }}
    >
      {children}
    </Context.Provider>
  );
};
